<!--
 * @Author: your name
 * @Date: 2020-03-02 19:14:11
 * @LastEditTime: 2021-07-15 14:19:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /nvoicep-h5/src/App.vue
-->
<template>
  <div id="app" :class="{xl:isXL}" v-if="bgColor" v-background-color="bgColor">
    <!-- <router-view></router-view> -->
    <keep-alive>
      <router-view v-if="$route.meta.keep"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keep"></router-view>
  </div>
</template>

<script>
import config from '@config'
  export default {
    name: 'app',
    data() {
      console.log('config',config)
      return {
        isXL: config.isXl,
        bgColor: '#FFFFFF',
        isShow: false
      }
    },
    components: {
    },
    mounted() {
      this.andriodInputBug();
    },
    watch: {
      $route:function(n,o){
        this.$toast.clear()
      }
    },
    methods: {

      //解决安卓点击input，弹出键盘挡住input的问题
      andriodInputBug() {
        if (/Android/gi.test(navigator.userAgent)) {
          window.addEventListener('resize', function () {
            if (document.activeElement.tagName == 'INPUT' || document.activeElement.tagName == 'TEXTAREA') {
              window.setTimeout(function () {
                document.activeElement.scrollIntoViewIfNeeded();
              }, 0);
            }
          })
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  #app{
    height: 100%;
    font-family:PingFang-SC-Regular;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue